import router from 'next/router'
import { useEffect } from 'react'

import { Redirect } from '@components/Redirect'
import { AppRoutes } from '@constants/app-routes'
import { CustomHead } from '@ui/sections/CustomHead'

function IntranetPortalForEducationCommunityPage() {
  useEffect(() => {
    router.replace(AppRoutes.intranetEducationCompany)
  }, [])

  return (
    <>
      <CustomHead
        title="Intranet Portal for Efficient Education Services"
        description="Learn how our team has developed a cutting-edge intranet portal for an education company and helped them to advance business operations and reduce time and money expenses"
        imagePath="/images/cases/intranet-portal-for-education-company/opengraph.webp"
      />
      <Redirect />
    </>
  )
}

export default IntranetPortalForEducationCommunityPage
